import React from 'react';
import { Item } from './Item';

export const ListItem = ({ data }) => {
  return data.map((data, index) => <Item key={index} item={data} isOdd={index % 2 === 0} />);
};
